import * as ng from 'angular';
import { AccountActivity, IAccountActivityResource } from './data/account-activity';
import { FrequentParkerActivity, IFrequentParkerActivityResource } from './data/frequent-parker-activity';
import { Message, IMessageResource } from './data/message';
import { Activities, IActivitiesService } from './services/activities-service';
import { ActivityGridComponent, IActivityGridController } from './user-controls/activity-grid';
import { AccountActivityComponent, IAccountActivityController } from './account-activity';
import { AccountInfoComponent, IAccountInfoController } from './account-info';
import { MediaComponent, IMediaController } from './media';
import { MessageComponent, IMessageController } from './message';
import { OverviewComponent, IOverviewController } from './overview';

import * as Dto from '../../data/interfaces';
//import { AdminComponent, IAdminController } from './admin';

// 3rd Party modules - to be added later
//'AngularPrint',
let DashboardModule = ng.module("app.dashboard", [
    'ngComponentRouter',    
    'ngMaterial',
    'ngAnimate',
    'ngMessages',
    'ngSanitize',
    'angularMoment'

]).factory(AccountActivity.name, AccountActivity.factory)
    .factory(FrequentParkerActivity.name, FrequentParkerActivity.factory)
    .factory(Message.name, Message.factory)
    .service(Activities.name, Activities.factory)
    .component(ActivityGridComponent.name, ActivityGridComponent.registration)
    .component(AccountActivityComponent.name, AccountActivityComponent.registration)
    .component(AccountInfoComponent.name, AccountInfoComponent.registration)
    .component(MediaComponent.name, MediaComponent.registration)
    .component(MessageComponent.name, MessageComponent.registration)
    .component(OverviewComponent.name, OverviewComponent.registration);

export {
    IAccountActivityResource, IFrequentParkerActivityResource, IMessageResource,
    IActivitiesService, IActivityGridController,
    IAccountActivityController, IAccountInfoController, IMediaController, IMessageController, IOverviewController,
    Dto
};
export default DashboardModule;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/dashboard/index.ts